import { Component, OnInit, OnDestroy, ElementRef, Input } from '@angular/core';
import * as ko from 'knockout';
import { CurrencyRateService } from './currency-rate-service';

let _ : any = require("lodash");
declare var DobryKantor: any;

@Component({
    selector: 'dk-currency-rates-history',
    template: require('./currency-rates-history.html'),
    entryComponents: [],
    providers: [ CurrencyRateService ]
})

export class CurrencyRatesHistoryComponent implements OnInit, OnDestroy {
    @Input() onClose: () => void;
    currencies: any[];
    selectedCurrency = DobryKantor.params.cantor.mainCurrency.toLowerCase();

    constructor(private element: ElementRef, currencyRateService: CurrencyRateService) {
        currencyRateService.getAllCantorCurrencies().subscribe((result) => {
            this.currencies = result;
        });
    }

    params() {
        return {
            currency: this.selectedCurrency
        };
    }

    ngOnInit() {
        this.bind();
    }

    ngOnDestroy() {
        this.clean();
    }

    selectedCurrencyChanged() {
        this.clean();
        this.bind();
    }

    bind() {
        this.element.nativeElement.querySelectorAll('dk-currency-chart').forEach((item) => {
            item.setAttribute('params', JSON.stringify(this.params()));
        });

        this.element.nativeElement.querySelectorAll('dk-nbp-currency-rate').forEach((item) => {
            item.setAttribute('params', JSON.stringify(this.params()));
        });

        ko.applyBindings({}, this.element.nativeElement);
    }

    clean() {
        ko.cleanNode(this.element.nativeElement);
    }
}
